import {
  Interface,
  type
} from 'implement-js';
import {
  RetailItemImageList
} from './RetailItemImage/retailItemImageList';
import {
  RetailItemCommPriceList
} from './RetailItemCommPrice/retailItemCommPriceList';
import {
  RetailItemCommFamilyPriceList
} from './RetailItemCommFamilyPrice/retailItemCommFamilyPriceList';
import {
  ItemMeasureList
} from './ItemMeasure/itemMeasureList';
import {
  RetailItemCommChildList
} from './RetailItemCommChild/retailItemCommChildList';
import { 
  RetailItemCommFeeList 
} from './RetailItemCommFee/retailItemCommFeeList';

export const ItemData = Interface('ItemData')({
  ItemNo: type('string'),
  ItemType: type('string'),
  ProductName: type('string'),
  ProductNameGlobal: type('string'),
  ProductTypeName: type('string'),
  ProductTypeNameGlobal: type('string'),
  ValidDesignText: type('any'),
  ValidDesignTextGlobal: type('any'),
  ItemUnitCode: type('string'),
  ItemMeasureReferenceTextMetric: type('any'),
  ItemMeasureReferenceTextImperial: type('any'),
  RetailItemImageList: type('object', RetailItemImageList),
  RetailItemCommPriceList: type('object', RetailItemCommPriceList),
  CurrencyRankList: type('array', [type('string')]),
  RetailItemCommFamilyPriceList: type('object', RetailItemCommFamilyPriceList),
  RetailItemCommFeeList: type('object', RetailItemCommFeeList),
  ItemMeasureList: type('object', ItemMeasureList),
  RetailItemCommChildList: type('object', RetailItemCommChildList)
}, {
    // when true, errors and warnings are triggered when properties
    // other than those on the Interface are found, is suppressed if
    // trim is set to true - default: false
    strict: false,

    // remove methods/properties that don’t match the Interface - default: false
    trim: true,

    // throws an error when Interface isn’t implemented - default: false
    error: true,

    // warns when Interface isn’t implemented - default: true
    warn: true
    //rename: { Prop1: 'ValidDesignText', Prop2: 'ValidDesignTextGlobal' }
});
